/* eslint-disable camelcase */
import { connectRouter, routerMiddleware } from "connected-react-router";
import { createStore, applyMiddleware, compose } from "redux";
import createLogger from "redux-logger";
import thunkMiddleware from "redux-thunk";
import Router from "common/helpers/router";
import rootReducer from "./rootReducer";

const loggerMiddleware = createLogger();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(
  preloadedState,
  railsContext,
  history,
  reducers
) {
  const { session, exposed_urls } = railsContext;
  let modifiedPreloadedState = {
    ...preloadedState,
    constants: {
      ...preloadedState.constants,
      ...railsContext,
    },
  };
  const middlewares = [thunkMiddleware, routerMiddleware(history)];

  if (exposed_urls) {
    Router.add(exposed_urls);
  }

  if (process.env.NODE_ENV !== "production") {
    middlewares.push(loggerMiddleware);
  }

  let combinedRootReducerAndPropsReducers;
  if (typeof reducers === "function") {
    combinedRootReducerAndPropsReducers = reducers;
  } else if (typeof reducers === "object") {
    combinedRootReducerAndPropsReducers = rootReducer(reducers);
  } else {
    combinedRootReducerAndPropsReducers = rootReducer({});
  }

  if (session && combinedRootReducerAndPropsReducers({}, {}).session) {
    modifiedPreloadedState = {
      ...modifiedPreloadedState,
      session,
    };
  }

  return createStore(
    connectRouter(history)(combinedRootReducerAndPropsReducers), // new root reducer with router state
    modifiedPreloadedState,
    composeEnhancers(applyMiddleware(...middlewares))
  );
}
